import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import BuildShowcase from './BuildShowcase';
import ProductPage from './ProductPage';
import './App.css';

// Preserves ?query params through the short-path redirects.  e.g. /shop?tab=details
// becomes /shop/r32-gtr-quadrant/213?tab=details so the PDP can open the right tab.
const NavigatePreservingQuery = ({ toPath }) => {
  const { search } = useLocation();
  return <Navigate to={`${toPath}${search}`} replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Marketplace homepage */}
        <Route path="/" element={<HomePage />} />

        {/* LOOK + LEARN menu → build showcase (POC: single build) */}
        <Route path="/look-and-learn" element={<NavigatePreservingQuery toPath="/build/r32-gtr-quadrant/213" />} />
        <Route path="/build/:slug/:id" element={<BuildShowcase />} />

        {/* SHOP menu → auction / product page (POC: single featured product) */}
        <Route path="/shop" element={<NavigatePreservingQuery toPath="/shop/r32-gtr-quadrant/213" />} />
        <Route path="/shop/:slug/:id" element={<ProductPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
